import type { UserLoginUsecase } from '@usecases/user-login.usecase';
import type { UserLoginRequest } from '@usecases/user-login.usecase';
import { InvalidUserLoginRequest } from '@usecases/user-login.usecase';
import type { BaseController } from '@infra/controllers/base.controller';

export type UserLoginInput = UserLoginRequest;

export type UserLoginOutput = InvalidUserLoginRequest | void;

export class UserLoginController
  implements BaseController<UserLoginInput, UserLoginOutput>
{
  constructor(private usecase: UserLoginUsecase) {}

  async handle(req: UserLoginInput): Promise<UserLoginOutput> {
    try {
      await this.usecase.run(req);
    } catch (error) {
      if (error instanceof InvalidUserLoginRequest) {
        return error;
      }

      throw error;
    }
  }
}
